import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/themes.css';
import ResearchMaintenancePage from './components/ResearchMaintenancePage';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ResearchMaintenancePage />
  </React.StrictMode>
);

// COMPLETELY DISABLE SERVICE WORKER - Unregister all existing service workers
if ('serviceWorker' in navigator) {
  // Unregister ALL service workers immediately
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Service Worker unregistered:', registration.scope);
    }
  }).catch(function(err) {
    console.log('Service Worker unregistration failed: ', err);
  });

  // Clear all caches
  if ('caches' in window) {
    caches.keys().then(function(names) {
      for (let name of names) {
        caches.delete(name);
        console.log('Cache cleared:', name);
      }
    });
  }

  console.log('Service Worker disabled - site will work normally without offline support');
}

// Performance monitoring
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }

  // You can also send to analytics
  // Example: sendToAnalytics(metric);
});
